import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface DailySpendChartProps {
  data: Array<{ day: string; openai: number; assemblyai: number }>;
  isLoading: boolean;
}

function formatDay(day: string): string {
  const d = new Date(day);
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

function formatUSD(value: number): string {
  return `$${value.toFixed(2)}`;
}

export const DailySpendChart: React.FC<DailySpendChartProps> = ({
  data,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm">
        <div className="h-4 bg-gray-200 rounded w-40 mb-4" />
        <div className="h-64 bg-gray-50 rounded animate-pulse" />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">
        Daily Spend — Last 30 Days
      </h3>
      {data.length === 0 ? (
        <div className="h-64 flex items-center justify-center text-gray-400 text-sm">
          No cost data yet
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <AreaChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="day"
              tickFormatter={formatDay}
              tick={{ fontSize: 11 }}
              stroke="#9ca3af"
            />
            <YAxis
              tickFormatter={(v) => `$${v}`}
              tick={{ fontSize: 11 }}
              stroke="#9ca3af"
              width={50}
            />
            <Tooltip
              formatter={(value: any, name: any) => [
                formatUSD(Number(value) || 0),
                name === 'openai' ? 'OpenAI' : 'AssemblyAI',
              ]}
              labelFormatter={(label: any) => formatDay(String(label))}
              contentStyle={{ fontSize: 12 }}
            />
            <Legend
              formatter={(value) =>
                value === 'openai' ? 'OpenAI' : 'AssemblyAI'
              }
              wrapperStyle={{ fontSize: 12 }}
            />
            <Area
              type="monotone"
              dataKey="openai"
              stackId="1"
              stroke="#3b82f6"
              fill="#93c5fd"
              fillOpacity={0.5}
            />
            <Area
              type="monotone"
              dataKey="assemblyai"
              stackId="1"
              stroke="#22c55e"
              fill="#86efac"
              fillOpacity={0.5}
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};
